module.exports = __webpack_public_path__ + "img/fccpc.cd80b545.png";